import {
    GetListExamsPointsResponse,
    PostExamsPointsRequest,
    getListExamsPoints,
    postExamsPoints,
} from '@yandex-int/k-common/client/api';
import { takeLatest, put, all, call, select } from 'redux-saga/effects';

import { getStudents } from 'common.components/classes/selectors';
import { Student } from 'common.components/typings';

import { actions } from './actions';

export function* examsResultsWatcher() {
    yield all([
        takeLatest(actions.getListExamsResultsRequest, sagaGetListExamsResultsRequest),
        takeLatest(actions.postExamsResultsRequest, sagaPostExamsResultsRequest),
    ]);
}

function* sagaGetListExamsResultsRequest(action: ReturnType<typeof actions.getListExamsResultsRequest>) {
    const results: GetListExamsPointsResponse = yield call(getListExamsPoints, action.payload.teamId);

    const students: Student[] = yield select(getStudents, { classId: action.payload.teamId });

    // TODO: snake_case vs camelCase
    yield put(actions.getListExamsResultsSuccess({ students, results: results as any }));
}

function* sagaPostExamsResultsRequest(action: ReturnType<typeof actions.postExamsResultsRequest>) {
    try {
        const results = Object.values(action.payload.results)
            .filter((result) => {
                if (result.points !== '') {
                    return true;
                } else if (result.score !== '') {
                    throw Error('classes.examsResults.noScoreWithoutPoints');
                }
                return false;
            })
            .map(({ student_id, exam_type, year, points, score }) => ({
                student_id,
                exam_type,
                year,
                points: Number(points),
                // Number(score) === 0 вынуждены проверять, ибо с какой-то вероятностью пустое поле обрабатывается как 0
                score: score === '' || Number(score) === 0 ? null : Number(score),
            }));

        yield call(postExamsPoints, {
            teamId: action.payload.teamId,
            results: results,
        } as PostExamsPointsRequest);

        yield put(actions.postExamsResultsSuccess());
    } catch (e) {
        if (e?.data?.error === 'team is archived') {
            yield put(actions.postExamsResultsError('classes.examsResults.teamIsArchived'));
        } else if (e?.message === 'classes.examsResults.noScoreWithoutPoints') {
            yield put(actions.postExamsResultsError(e.message));
        } else {
            yield put(actions.postExamsResultsError('classes.examsResults.somethingGoesWrong'));
        }
    }
}
